import api from './api'

export const usuarioService = {
  async getAll(params = {}) {
    const response = await api.get('/usuarios', { params })
    return response.data
  },

  async getById(id) {
    const response = await api.get(`/usuarios/${id}`)
    return response.data
  },

  async create(data) {
    const response = await api.post('/usuarios', data)
    return response.data
  },

  async update(id, data) {
    const response = await api.put(`/usuarios/${id}`, data)
    return response.data
  },

  // Soft delete - marca como eliminado
  async delete(id) {
    const response = await api.delete(`/usuarios/${id}`)
    return response.data
  },

  async updateRole(id, tipoUsuario) {
    const response = await api.put(`/usuarios/${id}/role`, { tipo_usuario: tipoUsuario })
    return response.data
  },

  async reactivar(id) {
    const response = await api.post(`/usuarios/${id}/reactivar`)
    return response.data
  },
}

